import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { fmtDate, fmtTime } from "@/lib/format";
import { Loader2, FileText, ChevronRight } from "lucide-react";

export default function DriverHistory() {
  const navigate = useNavigate();
  const { data: orders = [], isLoading } = useQuery({
    queryKey: ["driver-history"],
    queryFn: async () => (await api.get("/orders")).data,
  });
  const done = orders.filter((o) => ["Completed", "Partial Delivery", "Failed Delivery"].includes(o.status));

  return (
    <div className="animate-slide-up">
      <h1 className="font-head text-2xl font-extrabold text-[#0B192C]">Completed Deliveries</h1>
      <p className="text-sm text-slate-500">Your delivery history & PODs</p>

      {isLoading ? (
        <div className="flex justify-center py-12"><Loader2 className="animate-spin text-[#FF6500]" /></div>
      ) : done.length === 0 ? (
        <div className="mt-6 rounded-2xl border border-dashed border-slate-300 bg-white py-12 text-center text-slate-400">No completed deliveries yet.</div>
      ) : (
        <div className="mt-4 space-y-3">
          {done.map((o) => (
            <div key={o.id} className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={`history-card-${o.order_number}`}>
              <div className="flex items-center justify-between">
                <span className="font-mono text-sm font-bold text-[#FF6500]">#{o.order_number}</span>
                <StatusBadge status={o.status} />
              </div>
              <div className="mt-1 font-head font-bold text-[#0B192C]">{o.customer_snapshot.name}</div>
              <div className="mt-0.5 text-sm text-slate-500">
                {fmtDate(o.delivery?.completed_at || o.delivery_date)} · {fmtTime(o.delivery?.completed_at)} · {o.delivery?.time_on_site_minutes ?? "-"} min on site
              </div>
              <button
                onClick={() => navigate(`/driver/delivery/${o.id}`)}
                className="mt-2 flex w-full items-center justify-between rounded-lg bg-slate-50 px-3 py-2 text-sm font-semibold text-[#0B192C] tap-shrink"
                data-testid={`history-open-${o.order_number}`}
              >
                <span className="flex items-center gap-1.5"><FileText size={15} /> {o.pod_number}</span>
                <ChevronRight size={16} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
